import React from 'react';
import { VariableSizeList as List } from 'react-window';
import { AutoSizer } from 'react-virtualized';

const VirtualizedContent = ({
  data,
  header,
  headerHeight,
  rowHeight,
  rowRenderer,
  getItemSize,
  ...props
}) => (
  <AutoSizer>
    {({ height, width }) => (
      <div style={{ height, width }}>
        {header ? (
          <div style={{ height: `${headerHeight || rowHeight}px`, width }}>{header}</div>
        ) : null}
        <List
          height={500}
          itemCount={data.length}
          itemSize={getItemSize}
          // itemData={index => data[index]}
          // itemKey={index => data[index]?.id}
          // overscanCount={10}
          width="100%"
          {...props}
        >
          {rowRenderer}
        </List>
      </div>
    )}
  </AutoSizer>
);

export default VirtualizedContent;
